<template>
  <div class="dashboard">
    <common-layout>
      <div slot="header">
       <h3>发布控制</h3>
        <!-- <div class="dashboard_tabs">
          <span
            v-for="btn in tabs"
            :key="btn.id"
            @click="handleClick(btn.id)"
            :class="{'active_t':activeName== btn.id}"
          >{{btn.name}}</span>
        </div>
        <ul class="dashboard_nav">
          <li>内容管理</li>
          <li class="active-Tab">控制台</li>
        </ul> -->
      </div>
      
      <div slot="container">
        <div class="dashboard__create">
          <el-button type="primary" @click="createModal">创建新模式</el-button>
          <!-- <a href="https://lz.shyunhua.com/dev/market/publish/" target="_blank">大屏地址：https://lz.shyunhua.com/dev/market/publish/</a> -->
        </div>
        <div class="dashboard__content">
          <Lists :modulesList="modulesList" @updateEditModulesList="updateEditModulesList" />
        </div>
        <div class="dashboard__page">
          <el-pagination
            background
            layout="prev, pager, next"
            v-if="paginationMshow"
            @current-change="handleMCurrentChange"
            :current-page.sync="pageMNo"
            :page-size="pageMSize"
            :total="totalMCount"
          ></el-pagination>
        </div>
      </div>
    </common-layout>
    <create-modal
      :dialogCreate="dialogCreate"
      @closeCreateModal="closeModal"
      @updateEditModulesList="updateEditModulesList"
      :type="activeName"
    ></create-modal>
  </div>
</template>

<script>
import CreateModal from "./createModal.vue";
import Lists from "./lists.vue";
import CommonLayout from "../../components/common-layout.vue";

export default {
  components: {
    CommonLayout,
    CreateModal,
    Lists
  },
  data() {
    return {
      dialogCreate: false,
      activeName:1,
      tabs:[
          {
          id: 1,
          name: "1号大屏"
        },
        {
          id: 2,
          name: "2号大屏"
        },
        {
          id: 3,
          name: "自助服务站"
        },
      ],
      modulesList: [],
      pageMSize: 10,
      pageMNo: 1,
      paginationMshow: false,
      totalMCount: 0
      // userType:JSON.parse(this.$store.getters.userId)
    };
  },
  methods: {
    handleClick(val){
        this.activeName = val
        this.getData('Mode?type='+val)
    },
    createModal() {
      this.dialogCreate = true;
    },
    closeModal(val) {
      this.dialogCreate = val;
    },
    handleMCurrentChange(val) {
      this.getData('Mode?type='+this.activeName+"&page="+val)
    },
    getData(url) {
      let that = this;
      let params = {};
      if(url.indexOf('?') > -1){
        let urlParams = url.split('?')[1]?.split('&')
        urlParams.forEach(item => {
          params[item.split('=')[0]] = item.split('=')[1]
        })
      }

      this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/mode/page`, params).then(res=>{
          if(res.code == 0){
            this.modulesList = res.data.data
            this.pageMNo = res.data.current_page
            this.pageMSize = res.data.per_page
            this.totalMCount = res.data.total
            if(res.data.last_page > 1 ){
                this.paginationMshow = true
            }
          }
      })
    },
    updateEditModulesList() {
      this.getData('Mode?type='+this.activeName)
    }
  },
  mounted() {
      this.getData('Mode?type=1')
  }
};
</script>

<style lang="scss" scoped>
@include component(dashboard) {
  width: 100%;
  height: 100%;
  background: #fff;
//   margin: 1rem;
//   padding-left: 1rem;
//   padding-right: 1rem;
//   padding-bottom: 1rem;
  .dashboard_tabs {
    // width: 600px;
    height: 50px;
    border: 1px solid #ef9f49;
    display: flex;
    border-radius: 50px;
    overflow: hidden;
    cursor: pointer;

    > span {
      display: inline-block;
      width: 150px;
      height: 50px;
      line-height: 50px;
      font-weight: bold;

      &.active_t {
        background: linear-gradient(to bottom right, #fbc434 0%, #f66b4e 100%);
        color: #fff;
      }
    }
  }
  @include part(header) {
    width: 100%;
    height: 3.125rem;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #eee;
    h2 {
      font-weight: normal;
      padding-left: 1rem;
    }
  }

  .dashboard__create {
    padding: 1rem 0;
    text-align: left;
    a{
      margin-left: 20px;
      color: #409EFF;
      font-size: 16px;
    }
  }

  .dashboard__page {
    width: 100%;
    padding-top: 1rem;

    @include component(el-pagination) {
      text-align: center;
    }
  }
}
</style>